/* STATUS / AGENT NOTES (2026-10-05)
 * Agent START Codex: Scoped native variant refresh for server-validated design alternatives. */
(() => {
  if (customElements.get('scooch-other-designs')) return;
  class OtherDesigns extends HTMLElement {
    connectedCallback() {
      this.generation = 0;
      this.renderedHidden = this.hidden;
      this.onVariant = event => {
        const detail = event.detail || {};
        const formId = event.target?.getAttribute?.('id') || '';
        if (!formId.startsWith('product-form-main-' + this.dataset.productId + '-')) return;
        this.load(detail.variant);
      };
      document.addEventListener('variant:changed', this.onVariant);
      // Claude 2026-10-27: Deferred shells load the initial variant's cards as they near the viewport.
      if (this.dataset.src && this.dataset.initialVariantId && !this.dataset.variantId) {
        const initial = () => {
          if (this.generation === 0) this.load({ id: this.dataset.initialVariantId });
        };
        if (!('IntersectionObserver' in window)) initial();
        else {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            initial();
          }, { rootMargin: '1500px 0px' });
          this.observer.observe(this.parentElement || this);
        }
      }
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
      this.observer?.disconnect();
      this.controller?.abort();
      this.generation++;
    }
    async load(variant) {
      if (variant && String(variant.id) === this.dataset.variantId) {
        this.controller?.abort();
        this.generation++;
        this.hidden = this.renderedHidden;
        return;
      }
      const generation = ++this.generation;
      this.controller?.abort();
      this.hidden = true;
      if (!variant) return;
      this.controller = new AbortController();
      // Claude 2026-10-27: Prefer the cached data view; keep the section request for older markup.
      const url = this.dataset.src ? new URL(this.dataset.src, location.origin) : new URL(location.href);
      if (!this.dataset.src) url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('variant', variant.id);
      try {
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Design request failed');
        const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = fragment.querySelector('scooch-other-designs');
        if (generation !== this.generation || !this.isConnected || !payload
          || payload.dataset.productId !== this.dataset.productId || payload.dataset.variantId !== String(variant.id)) return;
        this.replaceChildren(...payload.childNodes);
        this.dataset.variantId = payload.dataset.variantId;
        this.renderedHidden = payload.hidden;
        this.hidden = payload.hidden;
      } catch (error) {
        if (generation === this.generation) this.hidden = true;
      }
    }
  }
  customElements.define('scooch-other-designs', OtherDesigns);
})();
/* Agent END Codex: Exact alternatives; abort and generation guards reject stale selections. */
